import { FiLogOut, FiKey } from "react-icons/fi";

function Header({ onLogout, onResetPassword, userName }) {
    const handleLogout = () => {
        localStorage.clear();
        if (onLogout) onLogout();
    };

    const handleResetPassword = () => {
        if (onResetPassword) onResetPassword();
    };

    return (
        <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4 mb-6">
            <div className="flex items-center justify-between w-full flex-wrap">
                {/* Left: Logo & Title */}
                <div className="flex items-center space-x-2">
                    <img
                        src="/sv.png"
                        alt="SV Solar Logo"
                        className="h-14 object-contain"
                    />
                    <div className="hidden sm:block">
                        <h1 className="text-lg font-bold text-gray-800">
                            Consumer Management System
                        </h1>
                        <p className="text-xs text-gray-500">Manage all consumer records</p>
                    </div>
                </div>

                {/* Right: Username + Actions */}
                <div className="flex items-center gap-3">
                    <span className="text-sm text-gray-700 font-medium hidden sm:block">
                        {userName}
                    </span>

                    <button
                        onClick={handleResetPassword}
                        className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded-lg text-sm flex items-center gap-1"
                        title="Reset Password"
                    >
                        <FiKey />
                        <span className="hidden sm:inline">Reset</span>
                    </button>

                    <button
                        onClick={handleLogout}
                        className="bg-red-600 hover:bg-red-700 text-white p-2 rounded-full shadow-md transition"
                        title="Logout"
                        aria-label="Logout"
                    >
                        <FiLogOut className="text-lg" />
                    </button>
                </div>
            </div>
        </header>
    );
}

export default Header;
